import { getThemes, getThemeClass } from '@controllers/themeController';
import { toggleTargetAttribute } from '@helpers/helpers';

export default function (widgetID, widgetOptions) {
  const widgetName = widgetID;
  const widgetOpts = widgetOptions;
  const $widgetHTML = $(`#${widgetName}`);

  const themes = getThemes();

  function modifyTitle(data) {
    const { Title: text } = data.items[0];
    const title = $widgetHTML.find('span.card-widget-title');
    title[0].outerHTML = `<h1 class="card-widget-title" aria-label="${text}">${text}</h1>`;
  }

  function altBtn() {
    const { class: fairTheme } = themes[1];
    const isFairTheme = getThemeClass() === fairTheme;

    if (isFairTheme) {
      $widgetHTML.find('.buttonwrap a').addClass('alt-button');
    }
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data) {
      if (data.items.length < 1) {
        $widgetHTML.remove();
      } else {
        modifyTitle(data);
        altBtn();
        toggleTargetAttribute($widgetHTML.find('a'));
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: true,
    imageIsBackground: true,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 4,
    moreButton: {
      visible: true,
      text: 'LEARN MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
